import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/Logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "layout-login__logo",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_2 = { class: "layout-login__wrap-input" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "layout-login__desc-input" }, "Восстановление доступа", -1)
const _hoisted_4 = { class: "layout-login__input-addons" }
const _hoisted_5 = { class: "layout-login__input-addons" }

import AuthLayout from "@/layouts/AuthLayout.vue";
import {
  KeyIcon,
  EyeIcon,
  EyeSlashIcon,
} from "tir-style-system/icons/outline";
import { TirPmInput } from "tir-pm-input";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-pm-button";

import { computed, onMounted, ref } from "vue";
import { TirPmPlate } from "tir-pm-plate";
import { TirPmStatusBudge } from "tir-pm-status-budge";

import ApiService from "@/shared/api";

import { useRoute, useRouter } from "vue-router";

/**
 * Инициализация апи
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'RestorePasswordPage',
  setup(__props, { expose: __expose }) {

const firstPassword = ref("");
const secondPassword = ref("");

const showFirstPassword = ref(false);
const showSecondPassword = ref(false);
const showPlateWarning = ref(false);

const api = new ApiService();

/**
 * Роутер
 */
let route = useRoute();
let router = useRouter();

/**
 * Токен из роута
 */
let routeQueryToken = route.query.token;
if (routeQueryToken[routeQueryToken.length - 1] == "/") {
  routeQueryToken = routeQueryToken.slice(0, -1);
}
console.log(routeQueryToken);

/**
 * Сообщение для ошибки
 */
const errorMessage = ref("");

/**
 * Лоадер для кнопки
 */
 const loadingRequest = ref(false)

/**
 * Перерасчет высоты
 */
 const loadingRequestComputed = computed(() => {
  return loadingRequest.value;
});

/**
 * Индикатор для совпадения паролей
 */
const isWithSuccessQual = computed(() => {
  return !!(
    firstPassword.value.length &&
    secondPassword.value.length &&
    firstPassword.value == secondPassword.value
  );
});
/**
 * Индикатор для смены видимости пароля
 */
const typeFirstPassword = computed(() => {
  return showFirstPassword.value ? "text" : "password";
});
/**
 * Индикатор для смены видимости пароля
 */
const typeSecondPassword = computed(() => {
  return showSecondPassword.value ? "text" : "password";
});

/**
 * Функция для восстановления пароля
 */
const onTypePassword = () => {};

/**
 * Функция для восстановления пароля
 */
const onRestorePassword = async () => {
  loadingRequest.value = true 
  try {
    if (
      firstPassword.value &&
      secondPassword.value &&
      firstPassword.value == secondPassword.value
    ) {
      let { IsSuccess, ErrorMessage } =
        await api.Main.UsersService.resetPasswordAsync({
          Token: routeQueryToken,
          NewPassword: secondPassword.value,
        });
      console.log(IsSuccess);
      if (!IsSuccess) {
        console.log(IsSuccess);
        showPlateWarning.value = true;
        errorMessage.value = ErrorMessage;
      } else {
        router.push("/login");
      }
    } else {
      showPlateWarning.value = true;
      errorMessage.value = "Пароли не совпадают";
    }
  } catch (err) {
    console.log(err);
    showPlateWarning.value = true;
    errorMessage.value = err.ErrorMessage;
  }
  loadingRequest.value = false 
};

const $currentComponentWrapper = ref(null);
const currentHeightComponent = ref(0);

/**
 * Проверка токена
 */
onMounted(() => {
  currentHeightComponent.value = $currentComponentWrapper.value?.offsetHeight;
  if (!route.query.token) {
    router.push("/login");
  }
});

__expose({
  changerMethodFromComponent: onRestorePassword,
  currentHeightComponent: currentHeightComponent,
  isLoadingIntoComponent: loadingRequestComputed,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "layout-login__body",
    ref_key: "$currentComponentWrapper",
    ref: $currentComponentWrapper
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode(_unref(TirPmPlate), {
        isShow: "",
        variant: "negative",
        isRounded: "",
        class: "layout-login__alert"
      }, {
        leftAddon: _withCtx(() => [
          _createVNode(_unref(TirPmStatusBudge), {
            "status-color": "negative",
            "status-icon-type": "alert"
          })
        ]),
        titleSlot: _withCtx(() => [
          _createTextVNode(" Ошибка ")
        ]),
        subtitleSlot: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMessage.value), 1)
        ]),
        _: 1
      }, 512), [
        [_vShow, showPlateWarning.value]
      ]),
      _createVNode(_unref(TirPmInput), {
        isAutocomplete: "",
        label: "Пароль",
        type: typeFirstPassword.value,
        onInput: onTypePassword,
        modelValue: firstPassword.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((firstPassword).value = $event)),
        placeholder: "",
        isWithHint: false,
        isWithSuccess: isWithSuccessQual.value,
        isWithError: showPlateWarning.value
      }, {
        leftInputAddons: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(KeyIcon))
          ])
        ]),
        hintMessage: _withCtx(() => []),
        rightInputAddons: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["layout-login__input-addons layout-login__input-addons--action", {
              'layout-login__input-addons--show': firstPassword.value.length,
            }])
          }, [
            (!showFirstPassword.value)
              ? (_openBlock(), _createBlock(_unref(EyeIcon), {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showFirstPassword.value = !showFirstPassword.value))
                }))
              : _createCommentVNode("", true),
            (showFirstPassword.value)
              ? (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showFirstPassword.value = !showFirstPassword.value))
                }))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["type", "modelValue", "isWithSuccess", "isWithError"]),
      _createVNode(_unref(TirPmInput), {
        isAutocomplete: "",
        label: "Повторите пароль",
        type: typeSecondPassword.value,
        onInput: onTypePassword,
        modelValue: secondPassword.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((secondPassword).value = $event)),
        placeholder: "",
        isWithHint: false,
        isWithSuccess: isWithSuccessQual.value,
        isWithError: showPlateWarning.value
      }, {
        leftInputAddons: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(KeyIcon))
          ])
        ]),
        hintMessage: _withCtx(() => []),
        rightInputAddons: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["layout-login__input-addons layout-login__input-addons--action", {
              'layout-login__input-addons--show': secondPassword.value.length,
            }])
          }, [
            (!showSecondPassword.value)
              ? (_openBlock(), _createBlock(_unref(EyeIcon), {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showSecondPassword.value = !showSecondPassword.value))
                }))
              : _createCommentVNode("", true),
            (showSecondPassword.value)
              ? (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
                  key: 1,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showSecondPassword.value = !showSecondPassword.value))
                }))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["type", "modelValue", "isWithSuccess", "isWithError"])
    ])
  ], 512))
}
}

})